import PersonIcon from '@mui/icons-material/Person'
import { Avatar } from '@mui/material'
import { useCurrentUser } from './hooks'

export default function MainWindow() {
  const [currentUser] = useCurrentUser()

  return (
    <div>
      <h1>Hello World!</h1>
      <Avatar
        sx={(theme) => ({
          mt: 2,
          marginLeft: 'auto',
          marginRight: 'auto',
          color: theme.palette.primary.main,
          width: theme.spacing(5),
          height: theme.spacing(5),
          cursor: 'pointer',
        })}
        src={currentUser?.avatarUrl || undefined}
      >
        {!currentUser?.avatarUrl && <PersonIcon />}
      </Avatar>
    </div>
  )
}
